import { createClient } from "@supabase/supabase-js";

// Supabase Configuration

const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || "YOUR_SUPABASE_PROJECT_URL";
const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY || "YOUR_SUPABASE_ANON_KEY";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

/**
 * رفع صورة إلى Supabase Storage
 * @param {File} file - ملف الصورة
 * @param {string} folder - المجلد (مثل 'ramadan-gifts')
 * @returns {Promise<{url: string, error: null} | {url: null, error: string}>}
 */
export const uploadImage = async (file, folder = "ramadan-gifts") => {
  try {
    if (!file.type.startsWith("image/")) {
      return { url: null, error: "الملف المرفوع ليس صورة" };
    }

    const fileExt = file.name.split(".").pop();
    const fileName = `${Date.now()}-${Math.random().toString(36).substring(7)}.${fileExt}`;
    const filePath = `${folder}/${fileName}`;

    const { error } = await supabase.storage
      .from("gifts-images")
      .upload(filePath, file, {
        cacheControl: "3600",
        upsert: false,
      });

    if (error) {
      console.error("Supabase upload error:", error);
      return { url: null, error: error.message };
    }

    const { data: publicUrlData } = supabase.storage
      .from("gifts-images")
      .getPublicUrl(filePath);

    return { url: publicUrlData.publicUrl, error: null };
  } catch (error) {
    console.error("Upload error:", error);
    return { url: null, error: "حدث خطأ أثناء رفع الصورة" };
  }
};

/**
 * حذف صورة من Supabase Storage
 * @param {string} url - رابط الصورة الكامل
 * @returns {Promise<boolean>}
 */
export const deleteImage = async (url) => {
  try {
    if (!url || !url.includes("supabase")) return false;

    const urlParts = url.split("/storage/v1/object/public/gifts-images/");
    if (urlParts.length < 2) return false;

    const filePath = urlParts[1];

    const { error } = await supabase.storage
      .from("gifts-images")
      .remove([filePath]);

    if (error) {
      console.error("Delete error:", error);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Delete error:", error);
    return false;
  }
};
